if (!customElements.get('theme-sticky-add-to-cart')) {
  customElements.define('theme-sticky-add-to-cart', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-sticky-bar]');
      this.submit = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      if (!this.bar || !this.submit) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      document.body.append(this.bar);
      this.button = this.bar.querySelector('[data-sticky-submit]');
      this.button.addEventListener('click', () => {
        if (!this.button.disabled && this.button.getAttribute('aria-disabled') !== 'true') this.submit.click();
      }, { signal });
      this.mirror = new MutationObserver(() => this.syncButton());
      this.mirror.observe(this.submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
      this.syncButton();
      this.visibility = new IntersectionObserver(([entry]) => {
        this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.update();
      });
      this.visibility.observe(this.submit);
      this.resize = new ResizeObserver(() => document.documentElement.style.setProperty('--theme-sticky-atc-height', `${this.bar.offsetHeight}px`));
      this.resize.observe(this.bar);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.refresh(data));
      }
      document.addEventListener('shopify:block:select', (event) => this.select(event, true), { signal });
      document.addEventListener('shopify:block:deselect', (event) => this.select(event, false), { signal });
      this.closest('.shopify-section')?.addEventListener('theme:offer-change', () => this.syncOffer(), { signal });
      window.matchMedia('(min-width: 990px)').addEventListener('change', () => this.syncOffer(), { signal });
      this.syncOffer();
    }
    syncOffer() {
      const offerPrice = this.bar.querySelector('[data-sticky-offer-price]');
      if (!offerPrice) return;
      const purchaseOffer = [...(this.closest('.shopify-section')?.querySelectorAll('theme-purchase-offers') || [])].find((offer) => offer.isActive?.());
      const totals = purchaseOffer?.getTotals(purchaseOffer.selected);
      offerPrice.hidden = !totals;
      this.bar.querySelector('[data-sticky-price]').hidden = Boolean(totals);
      if (!totals) return;
      offerPrice.querySelector('.price').classList.toggle('price--on-sale', totals.compare > totals.price);
      for (const amount of offerPrice.querySelectorAll('[data-sticky-offer-amount]')) amount.textContent = purchaseOffer.money.format(totals.price / 100);
      offerPrice.querySelector('[data-sticky-offer-compare]').textContent = purchaseOffer.money.format(totals.compare / 100);
    }
    select(event, selected) {
      if (event.detail?.blockId !== this.dataset.block) return;
      this.selected = selected;
      this.update();
    }
    syncButton() {
      this.button.disabled = this.submit.disabled;
      const busy = this.submit.getAttribute('aria-disabled');
      if (busy) this.button.setAttribute('aria-disabled', busy);
      else this.button.removeAttribute('aria-disabled');
      const label = [...this.submit.querySelectorAll(':scope > span')].find((span) => !span.classList.contains('hidden'))?.textContent.trim();
      if (label) this.button.querySelector('span').textContent = label;
    }
    refresh({ sectionId, html } = {}) {
      if (sectionId !== this.dataset.section || !html) return;
      const next = html.getElementById(this.bar.id);
      if (!next) return;
      for (const selector of ['[data-sticky-price]', '[data-sticky-media]']) {
        const source = next.querySelector(selector);
        const target = this.bar.querySelector(selector);
        if (source && target) target.innerHTML = source.innerHTML;
      }
    }
    update() {
      const visible = Boolean(this.passed || this.selected);
      this.bar.classList.toggle('is-visible', visible);
      this.bar.inert = !visible;
      document.body.classList.toggle('theme-sticky-atc-offset', visible && this.dataset.position === 'bottom');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.mirror?.disconnect();
      this.visibility?.disconnect();
      this.resize?.disconnect();
      this.unsubscribe?.();
      this.bar?.remove();
      document.body.classList.remove('theme-sticky-atc-offset');
    }
  });
}
